// extracted by mini-css-extract-plugin
export default {"container":"_6pZlWpOxeo6BwxvMHtNpgw"};